export type SketchEditWaiter = {
  ownerId: string
  projectId: number
  jobId: number
  editId: number
}

let waiter: SketchEditWaiter | null = null

export function setSketchEditWaiter(next: SketchEditWaiter | null) {
  waiter = next
}

export function getSketchEditWaiter(): SketchEditWaiter | null {
  return waiter
}

export function hasSketchEditWaiter(jobId: number): boolean {
  return waiter != null && waiter.jobId === jobId
}

export function clearSketchEditWaiter(jobId?: number) {
  if (jobId != null && waiter != null && waiter.jobId !== jobId) return
  waiter = null
}
